import { compose } from "recompose";
import { connect } from "react-redux";
import { isAnonymousUser } from "src/modules/auth/duck/selectors";

import EnterToken from "./EnterToken";

function mapStateToProps(state) {
  return {
    isAnonymousUser: isAnonymousUser(state)
  };
}

const enhance = compose(connect(mapStateToProps));
export default enhance(EnterToken);
